import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useSimpleChart } from './hooks/useSimpleChart';

export const SimpleChartIncrease = () => {
    const { values, subtitles } = useSimpleChart();
    
    return (
        <SimpleBars
            title={`Evolução do Valor do Incremento`}
            values={values}
            subtitles={subtitles}
            height={320}
            isMoney
        />
    );
};
